import { seguimientoDeadline } from "./seguimientoDeadline";
import { seguimientoSort } from "./seguimientoDefaults";
import SeguimientoFilters from "./SeguimientoFilterBar";
import { seguimientoFilters, seguimientoSearch, seguimientoWhatsAppUrl } from "./seguimientoFilterRules";
import HistoryModal from "./HistoryModal";
import React, { useState, useEffect } from "react";
import {
  useParams,
  useNavigate,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Pencil, Trash2, MessageSquarePlus, History, Play, MessageCircle } from "lucide-react";
import { toast } from "react-toastify";
import useResource from "../../shared/useResource";
import {
  Header,
  Toolbar,
  Pager,
  Status,
  Confirm,
  date,
  money,
} from "../../shared/UI";
import { request } from "../../api/http";
import ProspectoFormModal from "../../components/CRM/prospectos/ProspectoFormModal";
import OportunidadFormModal from "../../components/CRM/oportunidades/OportunidadFormModal";
import SeguimientoFormModal from "../../components/CRM/seguimientos/SeguimientoFormModal";
import {
  createProspecto,
  updateProspecto,
  createOportunidad,
  updateOportunidad,
  createSeguimiento,
  updateSeguimiento,
} from "../../api/uxbi";
const catalog = {
  prospectos: {
    label: "Prospectos",
    resource: "clientes",
    Form: ProspectoFormModal,
    create: createProspecto,
    update: updateProspecto,
  },
  oportunidades: {
    label: "Oportunidades",
    resource: "oportunidades",
    Form: OportunidadFormModal,
    create: createOportunidad,
    update: updateOportunidad,
  },
  seguimientos: {
    label: "Seguimientos",
    resource: "actividades",
    Form: SeguimientoFormModal,
    create: createSeguimiento,
    update: updateSeguimiento,
  },
};
export default function CRMPage() {
  const { kind } = useParams();
  const cfg = catalog[kind];
  const [search, setSearch] = useState(""),
    [page, setPage] = useState(1),
    [modal, setModal] = useState(null),
    [del, setDel] = useState(null),
    [busy, setBusy] = useState(false),
    [history, setHistory] = useState(null);
  const [followupFilters, setFollowupFilters] = useState({
    schedule: "",
    statuses: [],
    interviews: false,
  });
  const nav = useNavigate();
  const [query] = useSearchParams();
  const location = useLocation();
  useEffect(() => {
    if (query.get("nuevo")) setModal({});
    if (kind === "seguimientos" && location.state?.cliente)
      setModal(location.state);
  }, [kind, query, location.state]);
  const filter = kind === "seguimientos" ? seguimientoSearch(search) : search
    ? [
        {
          property: kind === "seguimientos" ? "notas_seguimiento" : "nombre",
          operator: "LIKE",
          value: search,
        },
      ]
    : [];
  if (kind === "seguimientos")
    filter.push(...seguimientoFilters(followupFilters));
  const path = `${
    cfg.resource
  }?context=${kind}&limit=25&page=${page}&perfil=listado_grid&filter=${encodeURIComponent(
    JSON.stringify(filter),
  )}${kind === 'seguimientos' ? `&sort=${encodeURIComponent(JSON.stringify(seguimientoSort()))}` : ''}`;
  const { data, loading, error, reload } = useResource(path);
  const F = cfg.Form;
  const save = async (payload) => {
    const result = await (modal?.id ? cfg.update : cfg.create)(payload);
    reload();
    return result;
  };
  const remove = async () => {
    setBusy(true);
    try {
      await request(`${cfg.resource}/${del.id}`, { method: "DELETE" });
      toast.success("Registro eliminado");
      setDel(null);
      reload();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <Header
        title={cfg.label}
        description="Organiza tu actividad comercial y da continuidad a cada cliente."
        onNew={() => setModal({})}
      />
      <Toolbar
        search={search}
        onSearch={(s) => {
          setSearch(s);
          setPage(1);
        }}
        onReload={reload}
        loading={loading}
      />
      {kind === "seguimientos" && (
        <SeguimientoFilters
          value={followupFilters}
          onChange={(value) => {
            setFollowupFilters(value);
            setPage(1);
          }}
        />
      )}
      <Status loading={loading} error={error} onRetry={reload} />
      {!loading && !error && (
        <div className="record-list">
          {(data?.data || []).map((r) => (
            <article className="record" key={r.id}>
              <div>
                <small>
                  #{r.id}
                  {r.clave ? ` · ${r.clave}` : ""}
                </small>
                <h3>{r.nombre || r.cliente?.nombre || "Seguimiento"}</h3>
                <p>
                  {kind === "seguimientos"
                    ? r.notas_seguimiento
                    : r.email || r.cliente?.nombre || r.razon_social || "—"}
                </p>
              </div>
              <div className="record-facts">
                {kind === "oportunidades" ? (
                  <>
                    <strong>{money(r.monto_proyecto)}</strong>
                    <span>
                      Cierre previsto: {date(r.fecha_tentativa_cierre)}
                    </span>
                  </>
                ) : kind === "seguimientos" ? (
                  <>
                    <Badge bg="light" text="dark">{r.estatus || "Pendiente"}</Badge>
                    <SeguimientoDueDate value={r.fecha_vencimiento} />
                  </>
                ) : (
                  <>
                    <span>{r.telefono || "Sin teléfono"}</span>
                    <span>{r.agente_ventas?.nombre || "Sin agente"}</span>
                  </>
                )}
              </div>
              <div className="record-actions">
                {kind === "seguimientos" && (<>
                  <Button as="a" size="sm" variant="light" title={seguimientoWhatsAppUrl(r) ? "Abrir WhatsApp" : "Cliente sin teléfono válido"} aria-label="Abrir WhatsApp" href={seguimientoWhatsAppUrl(r) || undefined} target="_blank" rel="noopener noreferrer" disabled={!seguimientoWhatsAppUrl(r)}>
                    <MessageCircle size={17} />
                  </Button>
                  <Button
                    size="sm"
                    variant="light"
                    title="Ver historial"
                    onClick={() => setHistory(r.id)}
                  >
                    <History size={17} />
                  </Button>
                </>)}
                {kind === "prospectos" && (
                  <Button
                    size="sm"
                    variant="light"
                    title="Ir a seguimientos"
                    onClick={() =>
                      nav("/crm/seguimientos", { state: { cliente: r } })
                    }
                  >
                    <MessageSquarePlus size={17} />
                  </Button>
                )}
                <Button
                  size="sm"
                  variant="light"
                  title={kind === "seguimientos" ? "Ejecutar seguimiento" : "Editar"}
                  aria-label={kind === "seguimientos" ? "Ejecutar seguimiento" : "Editar"}
                  onClick={() => setModal(r)}
                >
                  {kind === "seguimientos" ? <Play size={17} /> : <Pencil size={17} />}
                </Button>
                <Button
                  size="sm"
                  variant="light"
                  title="Eliminar"
                  onClick={() => setDel(r)}
                >
                  <Trash2 size={17} />
                </Button>
              </div>
            </article>
          ))}
          {!data?.data?.length && (
            <div className="empty">No hay registros con estos filtros.</div>
          )}
        </div>
      )}
      <Pager data={data} page={page} setPage={setPage} />
      {modal && (
        <F
          show
          record={Object.keys(modal).length ? modal : null}
          isEditMode={!!modal.id}
          onHide={() => setModal(null)}
          onSubmit={save}
          onCreateSeguimiento={(seed) => {
            setModal(null);
            nav("/crm/seguimientos", { state: seed });
          }}
          onSaved={() => {
            setModal(null);
            reload();
          }}
        />
      )}
      {history && (
        <HistoryModal id={history} onClose={() => setHistory(null)} />
      )}
      {del && (
        <Confirm
          title="Eliminar registro"
          busy={busy}
          onClose={() => setDel(null)}
          onConfirm={remove}
        >
          ¿Deseas eliminar este registro? El ERP validará sus relaciones antes
          de continuar.
        </Confirm>
      )}
    </>
  );
}

function SeguimientoDueDate({ value }) {
  const deadline = seguimientoDeadline(value);
  return (
    <span className={`seguimiento-deadline seguimiento-deadline--${deadline.tone}`}>
      {deadline.tone === "sin-fecha" ? deadline.label : `${deadline.label} · ${date(value)}`}
    </span>
  );
}
